import AspectRatioCover from '@comp/AspectRatioCover'
import Link from 'next/link'
import { article } from '@lib/route/news'
import { useLocale } from 'next-intl'

export function News({
  data
}) {
  const locale = useLocale()

  return (
    <Link href={article(data, locale)} className="border p-pix-20 flex gap-x-pix-20 flex-col gap-y-pix-10 sm:flex-row">
      <div className="aspect-[170/120] w-full sm:w-pix-170 sm:h-pix-120">
        <AspectRatioCover
          src={data.cover}
          width={170}
          height={120}
          alt="cover"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col items-start gap-y-pix-10">
        <div className="text-f.9 font-semibold line-clamp-3">{data.pureLabel}</div>
      </div>
    </Link>
  )
}
